import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Helmet from "react-helmet";

import mainTheme from "mainTheme";
import EmailPage from "email/EmailPage";
import GlobalFonts from "./fonts/Fonts";
import LoginPage from "./login/LoginPage";
import MainPage from "./MainPage";
import EventDetail from "./map/EventDetail";
import PageNotFound from "./PageNotFound";
import useRouterController from "./useRouteController";
import { DataProvider } from "./utils/usePrepareData";
// const fonturl = "fonts/";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";

function MetaInformations() {
  return (
    <Helmet>
      <title>{mainTheme.appTitle}</title>
      <link rel="icon" href={mainTheme.logoOrange} />
      <link rel="apple-touch-icon" href={mainTheme.logoOrange} />
    </Helmet>
  );
}
function RouteController() {
  const redirectDone = useRouterController();
  if (!redirectDone) {
    return null;
  }
  return <Outlet />;
}

function MainRoutes() {
  return (
    <Routes>
      <Route element={<RouteController />} path="/">
        <Route element={<LoginPage />} path="/login" />
        <DataProvider>
          <Routes>
            <Route element={<EmailPage />} path="/sendEmail" />
            <Route element={<MainPage />} path="/map">
              <Route element={<EventDetail />} path="event/:eventId" />
            </Route>
          </Routes>
        </DataProvider>
        <Route element={<PageNotFound />} path="*" />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <MetaInformations />
      <GlobalFonts />
      <MainRoutes />
      <NotificationContainer />
    </Router>
  );
}
